import Api from '../utils/api'

export const getCategories = async (params = {}) => {
  return await Api.get('/categories', params).then((res) => {
    return res
  })
}

